import Vue from "vue";
import LoadingBase from "./LoadingBase.vue";
import { OverlayManager } from "../overlay-manager.js";

class LoadingManager {
  static base = null;
  static loadIDs = {};
  static show(id) {
    if (Object.keys(this.loadIDs).length == 0) {
      this.loadIDs[id] = true;
      let loaderBase = Vue.extend(LoadingBase);
      let loader = new loaderBase({
        parent: OverlayManager.getOverlayBase(),
        //propsData: options,
      });
      loader.$mount();
      this.base = loader;
    } else {
      this.loadIDs[id] = true;
    }
  }
  static close(id) {
    delete this.loadIDs[id];
    if (Object.keys(this.loadIDs).length == 0) {
      this.base.close();
      this.base.$destroy();
      this.base = null;
    }
  }
}

export default LoadingManager;
